import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import Cookies from "js-cookie";

// Auth - Login
export const AuthLogin = createAsyncThunk(
  "auth/login/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

// GET Auth - Login
export const GETAuthLogin = createAsyncThunk(
  "auth/login/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Auth);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const dashboard = createAsyncThunk(
  "dashbord/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Dashboard);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const AuthLogOut = createAsyncThunk(
  // Auth - Logout
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      // const res = await GET(APIS.Auth);
      Cookies.remove("jeetomax_admin_security", { path: "/" });
      return {
        data: {},
        token: null,
        role: null,
        permissions: null,
        isLogin: false,
        error: null,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const ChangePasswordData = createAsyncThunk(
  "auth/login/change-password",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ChangePassword, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Slice = createSlice({
  name: "auth",
  initialState: {
    data: {},
    token: null,
    role: null,
    permissions: null,
    isLogin: false,
    status: IDS.SLICESTATUS.Idle,
    error: null,
    all_permission: {},
    all_dashboard: {},
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(AuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload?.data?.token;
        state.role = action.payload?.data?.role;
        state.permissions = action.payload?.data?.permissions;
        state.isLogin = true;
      })
      .addCase(AuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })
      .addCase(ChangePasswordData.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ChangePasswordData.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload?.data?.token;
        state.role = action.payload?.data?.role;
        state.permissions = action.payload?.data?.permissions;
        state.isLogin = true;
      })
      .addCase(ChangePasswordData.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })
      .addCase(GETAuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETAuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(GETAuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        // state.isLogin = false;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      //
      .addCase(AuthLogOut.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogOut.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      .addCase(AuthLogOut.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(dashboard.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(dashboard.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_dashboard = action.payload?.data;
      })
      .addCase(dashboard.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
